export interface DestinationSheetFooterProps {
  busy: boolean;
  existing: boolean;
  /** Whether the stored destination can be tested from the sheet, and what the button says. */
  check: string | null;
  /** What the submit button says ("Add", "Save", "Add and connect"). */
  submit: string;
  onCancel: () => void;
  /** Remove: the card closes the sheet and asks first (RemoveDestinationDialog). */
  onRemove: () => void;
  onCheck: () => Promise<void>;
}

/** The sheet's actions: Remove and the check on the left, Cancel and the submit on the right. */
export function DestinationSheetFooter(props: DestinationSheetFooterProps) {
  const { busy, existing, check, submit, onCancel, onRemove, onCheck } = props;
  return (
    <footer className="paige-destination-actions-row">
      {existing && (
        <button type="button" className="quiet-button danger" disabled={busy} onClick={onRemove}>
          Remove
        </button>
      )}
      {check && (
        <button
          type="button"
          className="quiet-button"
          disabled={busy}
          onClick={() => void onCheck()}
        >
          {check}
        </button>
      )}
      <span className="spacer" />
      <button type="button" className="secondary-button" disabled={busy} onClick={onCancel}>
        Cancel
      </button>
      <button type="submit" className="primary-button" disabled={busy}>
        {submit}
      </button>
    </footer>
  );
}
